import { useEffect, useRef, useState } from 'react'
import OutsideClickComponent from '../../fragments/OutsideClickComponent'
import { useCanEditArchived } from '../../../lib/usersPermissions'

import classes from './CustomSelect.module.css'
import BodySimpleModal from '../modal/BodySimpleModal'

export default function CustomSelectGroupedMultiple({name, label, optionsData, preSelectedValue, action, identifier, sameSizeAsContainer, minWidth, reverseDrawer, rtlDrawer, bkTransparent, borderRed, hasRemove, noticeDisabled, isDisabled, thin_select, fixedDrawer, undetermined, rebuild}) {
    // let masterDisable = useCanEdit()
    let editArchivedDisabled = useCanEditArchived()
    const toFocus = useRef(null)

    const [showDrawer, setShowDrawer] = useState(false)
    const [inputValue, setInputValue] = useState('')
    const [selectedValue, setSelectedValue] = useState([]) //in multiple this is an array!!!!!
    const [selectedValueArray, setSelectedValueArray] = useState([]) // send forward only the values, not the whole items

    const [options, setOptions] = useState(optionsData)
    
    function blurHandler() {
        setShowDrawer(false)
        // setSelectedHidden(false)
        setOptions(optionsData) // clear the filters
    }
    function focusHandler() {
        setShowDrawer(true) // show drawer on focus
    }

    function changeInputhandler(event) {
        setInputValue(event.target.value)
        const query = (event.target.value ?? '').toString().toLowerCase()

        let filtered = []
        optionsData.forEach(item => {
            if (item && item.options && !item.isDisabled) {
                let filteredoptions = item.options.filter(opt => !opt.isDisabled && opt.label.toString().toLowerCase().includes(query))
                if (filteredoptions && filteredoptions.length) {
                    filtered.push({
                        ...item,
                        options: filteredoptions
                    })
                }
            }
        })
        // setOptions(filteredOptions)  
        setOptions(filtered)      
    }

    function setOptionHandler(item) {
        setInputValue('') //clear input
        
        setOptions(optionsData) // clear the filters
        let optionAllreadySelected = selectedValue?.find(val => val.value === item.value)

        if (optionAllreadySelected) { // remove the value
   
            setSelectedValue(selectedValue.filter((a => a.value !== item.value)))
            setSelectedValueArray(selectedValueArray.filter((a => a !== item.value)))

            if (action) {
                action({
                    data: {
                        value: selectedValueArray.filter((a => a !== item.value))
                    },
                    identifier: identifier,
                    options: selectedValue.filter((a => a.value !== item.value))
                })
            }
        } else {  
                // setSelectedValue(prevArr => prevArr = [...prevArr, item])
                setSelectedValue([...selectedValue, item])
                // setSelectedValueArray(prevArr => prevArr = [...prevArr, item.value])
                setSelectedValueArray([...selectedValueArray, item.value])

            if (action) {
                action({
                    data: {
                        value: [...selectedValueArray, item.value]
                    },
                    identifier: identifier,
                    options: [...selectedValue, item]
                })
            }
     
        }       

    }

    function removeSingleSelected(item, event) {
        event?.stopPropagation?.()
        event?.preventDefault?.()

        setInputValue('') //clear input
        setOptions(optionsData) // clear the filters

        const nextSelected = selectedValue.filter((a) => a.value != item.value)
        const nextValuesArr = selectedValueArray.filter((a) => a != item.value)

        setSelectedValue(nextSelected)
        setSelectedValueArray(nextValuesArr)

        if (action) {
            action({
                data: {
                    value: nextValuesArr,
                },
                identifier: identifier,
                options: nextSelected,
            })
        }
    }

    const justToggledClosedByMouseDownRef = useRef(false)

    function focusSelectOnClickHandler() {
        if (justToggledClosedByMouseDownRef.current) {
            justToggledClosedByMouseDownRef.current = false
            return
        }
        if (showDrawer) return
        setShowDrawer(true)
        // setSelectedHidden(true) //if there is a selected value, need to set it hidden
        if (toFocus && toFocus.current) {
            toFocus.current.focus()
        }
    }

    function toggleOnMouseDownHandler(event) {
        if (showDrawer) {
            event.preventDefault()
            justToggledClosedByMouseDownRef.current = true
            blurHandler()
            toFocus.current?.blur()
        }
    }

    useEffect(() => {
        if (optionsData && Array.isArray(preSelectedValue) && preSelectedValue.length) {
            let allOptions = []
            optionsData.forEach(element => {
                if (element && element.options) {
                    allOptions = [...allOptions, ...element.options]
                }
            });

            const nextSelected = []
            const nextValues = []
            for (let index = 0; index < preSelectedValue.length; index++) {
                let foundOption = allOptions.find(item => item.value == preSelectedValue[index])
                if (foundOption) {
                    nextSelected.push(foundOption)
                    nextValues.push(foundOption.value)
                }
            }

            setSelectedValue(current => {
                if (current.length == nextSelected.length && current.every((item, i) => item.value == nextSelected[i].value)) {
                    return current
                }
                return nextSelected
            })
            setSelectedValueArray(current => {
                if (current.length == nextValues.length && current.every((item, i) => item == nextValues[i])) {
                    return current
                }
                return nextValues
            })
        } else {
            setSelectedValue(current => current.length ? [] : current)
            setSelectedValueArray(current => current.length ? [] : current)
        }
    }, [optionsData, preSelectedValue, rebuild])

    useEffect(() => {
        if (optionsData) {
            setOptions(optionsData)
        }
    }, [optionsData])

    if (!optionsData) { // no options were sent
        return <div className={`${classes.container}`} style={{minWidth: minWidth ? minWidth : ''}}>
            <OutsideClickComponent task={blurHandler}>
                
                <div className={classes.input_container}>
                    {label && <span className={classes.label}>{label}</span>}
                    <input name={name + '_no_options'} type='text' className={classes.input} autoComplete="off" onChange={() => {}} value={inputValue ? inputValue : ''}/>
                    <div className={classes.selected}>No data available</div>
                    <div className={`select_pointer ${classes.pointer}`}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                            <path d="M4.5 6.75L9 11.25L13.5 6.75" stroke="#577988" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                </div>
            </OutsideClickComponent>
        </div>
    }

    return <div className={`${classes.container} ${(showDrawer || (selectedValue && selectedValue.length > 0)) ? classes.is_focused : ''} ${!label && classes.no_label_container} ${thin_select ? classes.thin_select : ''} ${sameSizeAsContainer ? classes.same_size_as_container : ''} ${isDisabled ? classes.is_inactive : ''} ${editArchivedDisabled ? classes.is_inactive : ''}`} style={{minWidth: minWidth ? minWidth : ''}}>
        <OutsideClickComponent task={blurHandler}>   
            <div className={`${classes.input_container}`} onMouseDown={toggleOnMouseDownHandler} onClick={focusSelectOnClickHandler}>
                {label && <div className={classes.label}>{label}</div>}
                
                <div className={`${classes.input_container_multiple}`}>
                    {selectedValue && selectedValue.length > 0 && <>
                        {selectedValue.map((item, chipIndex) => (
                            <span
                                key={`chip_${String(item.value ?? 'null')}_${chipIndex}`}
                                className={classes.selected_single_item}
                            >
                                <span className={classes.chip_label}>{item.label}</span>
                                <button
                                    type="button"
                                    className={classes.chip_remove_btn}
                                    title="Remove"
                                    aria-label={`Remove ${item.label}`}
                                    onClick={(e) => removeSingleSelected(item, e)}
                                >
                                    <i className="ti ti-x"></i>
                                </button>
                            </span>
                        ))}
                    </>}

                    <input ref={toFocus} name={name} type='text' onChange={changeInputhandler} onFocus={focusHandler} className={classes.input} value={inputValue} autoComplete="off"/>
                    {/* {selectedValue && selectedValue.length > 0 && <div className={classes.selected_container}>
                        {selectedValue.map(item => (
                            <div key={item.value + Math.random()} title='remove item' className={classes.selected_single_item}>{item.label}</div>
                        ))}    
                    </div>}

                    <input name={name} type='text' onChange={changeInputhandler} onFocus={focusHandler} className={classes.input} value={inputValue} autoComplete="off"/> */}
                </div>
           
                <div className={`${classes.pointer} ${showDrawer && classes.opened}`}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <path d="M4.5 6.75L9 11.25L13.5 6.75" stroke="#577988" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
            </div>
            {showDrawer && <div className={classes.drawer}>
                {options && options.filter(item => !item.isDisabled && item.options && item.options.some(opt => !opt.isDisabled)).map(item => (
                    <div key={item.label}>
                        <p className={classes.group_label}>{item.label}</p>
                        {item.options && item.options.filter(opt => !opt.isDisabled).map(opt => (
                            <div key={opt.value}>
                                <button onClick={setOptionHandler.bind(this, opt)} className={`${classes.option} ${(selectedValue && (selectedValue.find(val => val.value === opt.value))) ? classes.option_selected : ''}`} disabled={opt.manual_selection}>{opt.label}</button>
                            </div>
                        ))}
                    </div>
                ))}
            </div>}
        </OutsideClickComponent>

        <BodySimpleModal isDisabled={isDisabled} messages={noticeDisabled}/>
    </div>
}